export default function ShinyButton( { icon, text, link, color } ){
    return(
        <a href = { link } target = "_blank">
            <button className = "shiny-button" style = { { background : color } }>
                <img className = "logo2" src = { icon }/>
                <p style = { { padding : 0, margin : 0, color : "white", fontSize : "var(--font-size-tiny)" } }>{ text }</p>
                <div className = "shine"></div>
            </button>
        </a>
    )
}